import {io} from 'socket.io-client'
import {makeAutoObservable} from "mobx";


export class SocketStore {
    socket = {}

    constructor() {
        makeAutoObservable(this)
    }

    connect = () => {

        this.socket = io.connect(process.env.REACT_APP_SOCKET_HOST || 'http://localhost:3030', {path: '/socket'})
        this.listeners(this.socket)

    }

    addListeners = (func) => {
        func(this.socket)
    }

    listeners = (socket) => {


    }

}

export default new SocketStore()
